import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getCartCount, getCartTotal } from "../../../services";
import { removeFromCart } from "../../../actions";
import { safeContent } from "../../../utils";

import {
  removeVariantFromCartlist,
  getCartList,
  removePackFromCartlist,
} from "../../../actions/cartlistActions";

function CartMenu(props) {
  const { cartlist, removeFromCart } = props;
  let total = getCartTotal(cartlist);

  let cartlistTotal = props.cartlistTotal;
  let cartSellingPrice = props.cartSellingPrice;
  let usercartlistvariants = props.usercartlistvariants;
  let usercartlistpacks = props.usercartlistpacks;

  return (
    <div className="dropdown cart-dropdown">
      <Link
        to={`${process.env.REACT_APP_PUBLIC_URL}/shop/cart`}
        className={
          props.innav ? "dropdown-toggle text-white" : "dropdown-toggle"
        }
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-display="static"
      >
        <i
          className={
            props.innav ? "icon-shopping-cart text-white" : "icon-shopping-cart"
          }
          id="cart-icon"
        ></i>
        <span className={props.innav ? "cart-count text-white" : "cart-count"}>
          {cartlistTotal}
        </span>
        <span className={props.innav ? "cart-txt text-white" : "cart-txt"}>
          Panier
        </span>
      </Link>

      <div
        className={`dropdown-menu dropdown-menu-right ${
          cartlistTotal === 0 ? "text-center" : ""
        }`}
      >
        {0 === cartlistTotal ? (
          <p>Aucun produit dans le panier.</p>
        ) : (
          <>
            <p
              style={{ paddingBottom: "15px" }}
              style={{ color: "black", marginBottom: "15px" }}
            >
              VARIANTES :
            </p>
            <div className="dropdown-cart-products">
              {usercartlistvariants.map((item, index) => (
                <div className="product" key={index}>
                  <div className="product-cart-details">
                    <h4 className="product-title">{item.variant.nameFr}</h4>

                    <span className="cart-product-info">
                      <span className="cart-product-qty">{item.qty}</span>x{" "}
                      {item.variant._sellingPrice.toFixed(2)} MAD
                    </span>
                  </div>

                  <figure className="product-image-container">
                    {/*<Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/7` } className="product-image">
                                                <img src={ process.env.REACT_APP_PUBLIC_URL + '/' + item.pictures[ 0 ] } data-oi={ process.env.REACT_APP_PUBLIC_URL + '/' + item.pictures[ 0 ] } alt="product" />
                                            </Link>*/}
                  </figure>
                  <button
                    className="btn-remove"
                    title="Remove Product"
                    onClick={(e) => {
                      props.removeVariantFromCartlist(item.variant.id);
                      props.getCartList();
                    }}
                  >
                    <i className="icon-close"></i>
                  </button>
                </div>
              ))}
            </div>

            <p
              style={{ paddingBottom: "15px" }}
              style={{ color: "black", marginBottom: "15px" }}
            >
              PACKS :
            </p>
            <div className="dropdown-cart-products">
              {usercartlistpacks.map((item, index) => (
                <div className="product" key={index}>
                  <div className="product-cart-details">
                    <h4 className="product-title">{item.pack.nameFr}</h4>

                    <span className="cart-product-info">
                      <span className="cart-product-qty">{item.qty}</span>x{" "}
                      {item.pack.price} MAD
                    </span>
                  </div>

                  <figure className="product-image-container">
                    {/*<Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/7` } className="product-image">
                                                <img src={ process.env.REACT_APP_PUBLIC_URL + '/' + item.pictures[ 0 ] } data-oi={ process.env.REACT_APP_PUBLIC_URL + '/' + item.pictures[ 0 ] } alt="product" />
                                            </Link>*/}
                  </figure>
                  <button
                    className="btn-remove"
                    title="Remove Product"
                    onClick={(e) => {
                      props.removePackFromCartlist(item.pack.id);
                      props.getCartList();
                    }}
                  >
                    <i className="icon-close"></i>
                  </button>
                </div>
              ))}
            </div>
            <div className="dropdown-cart-total">
              <span>Total</span>

              {/*<span className="cart-total-price">{ total.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>*/}
              <span className="cart-total-price">
                {cartSellingPrice.toFixed(2)} MAD
              </span>
            </div>

            <div className="dropdown-cart-action">
              <Link
                to={`${process.env.REACT_APP_PUBLIC_URL}/shop/cart`}
                className="btn btn-primary"
              >
                View Cart
              </Link>
              <Link
                to={`${process.env.REACT_APP_PUBLIC_URL}/shop/checkout`}
                className="btn btn-outline-primary-2"
              >
                <span>Checkout</span>
                <i className="icon-long-arrow-right"></i>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    usercartlistvariants: state.usercartlist.cartlist_variants
      ? state.usercartlist.cartlist_variants
      : [],
    usercartlistpacks: state.usercartlist.cartlist_packs
      ? state.usercartlist.cartlist_packs
      : [],
    cartlist: state.cartlist.cart ? state.cartlist.cart : [],
    cartlistTotal: state.usercartlist.total ? state.usercartlist.total : 0,
    cartSellingPrice: state.usercartlist.sellingPrice
      ? state.usercartlist.sellingPrice
      : 0,
  };
}

export default connect(mapStateToProps, {
  removeFromCart,
  removeVariantFromCartlist,
  getCartList,
  removePackFromCartlist,
})(CartMenu);
